<template>
  <CustomersWizardStatus />
</template>

<script>
// @ is an alias to /src
import CustomersWizardStatus from "@/sections/voiceplus/components/CustomersWizardStatus.vue";

export default {
  name: "CustomersWizardStatusView",
  components: {
    CustomersWizardStatus,
  },
};
</script>
